import React from 'react';
import { SelectableItem } from '../../../../../../models/CampaignModel';
import ProductCardFace from './ProductCardFace';

import './product-card.scss';

interface PropsCard {
  product: SelectableItem;
  shouldFocus: boolean;
  toggleProductSelection: (product: SelectableItem) => void;
  isOpen: boolean;
  isSelected: boolean;
}

export const ProductCard: React.FC<PropsCard> = ({ product, shouldFocus, toggleProductSelection, isOpen, isSelected }) => (
  <li className="product-card">
    <ProductCardFace
      shouldFocus={shouldFocus}
      toggleProductSelection={() => toggleProductSelection(product)}
      product={product}
      isOpen={isOpen}
      isSelected={isSelected}
    />
  </li>
);
